import { render, staticRenderFns } from "./Case.vue?vue&type=template&id=c6ce8142&"
import script from "./Case.vue?vue&type=script&lang=ts&"
export * from "./Case.vue?vue&type=script&lang=ts&"
import style0 from "./Case.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports